<template>
  <div>
		<div class="modal-history-guest">
			<div class="background-modal-guest">
				<div class="container-modal">
				<div class="section-history-guest">
				<table-run
				class="no-selectable-table"
				:selectable="false"
				:include-delete="false"
				:include-export-to-excel="false"
				:include-options="true"
				:include-search="false"
				:include-switch="false"
				:include-settings="true"
				:include-delete-single="false"
				:columns="columns"
				:rows="rows">
					<template slot="rows" scope="props">
						<td>{{props.row.number}}</td>
						<td>{{props.row.date}}</td>
						<td>{{props.row.hour}}</td>
						<td>{{props.row.product}}</td>
						<td>{{props.row.gast}}</td>
					</template>
				</table-run>
			</div>
				<v-layout justify-end>
					<v-flex mt-5 align-right>
					<v-btn
					class="btn-cancel green"
					@click="closeModal">
					Cerrar
						</v-btn>
					</v-flex>
				</v-layout>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import tableRun from 'table-run';
import mixin from '@/shared/mixins';

function created() {
	this.loadModalHistory();
}


function closeModal() {
	this.$emit('close');
}

async function loadModalHistory() {
	try {
		const baseUrl = process.env.PMS_URL;
		const { data: billing } = await this.$http.get(`${baseUrl}/details-accounts/${this.bookingCode}/payments`);
		this.billingDetail = billing.data;
		this.currencySelected = billing.data.currency || billing.data.saleDocument.currency;
	} catch (error) {
		this.showNotification('No se encontraron documentos', 'info');
	}
}

function data() {
	return {
		currencySelected: '',
		rows: [],
		billingDetail: {},
		columns: [
			{ id: 1, name: '# Comprobante' },
			{ id: 2, name: 'Fecha' },
			{ id: 3, name: 'Hora' },
			{ id: 4, name: 'Producto' },
			{ id: 5, name: 'Gasto' },
		],
	};
}
export default {
	name: 'modal-guest',
	data,
	created,
	mixins: mixin,
	components: {
		tableRun,
	},
	methods: {
		closeModal,
		loadModalHistory,
	},
	props: {
		bookingCode: String,
	},
};
</script>

<style lang="scss" scoped>
.background-modal-guest {
	background-color: white;
	padding: 15px;
}

.container-modal {
	display: flex;
	flex-direction: column;
}

.modal-history-guest {
	align-items: center;
	background: rgba(0, 0, 0, 0.42);
	bottom: 0;
	content: '';
	display: flex;
	height: 100%;
	justify-content: center;
	left: 0;
	position: fixed;
	right: 0;
	top: 0;
	width: 100%;
	z-index: 10;
}

.section-history-guest {
	width: 645px;
	height: 42px;
	background-color: white;
}
</style>



// WEBPACK FOOTER //
// modal-history-guest.vue?21efde6c